const _OrderFormsShowHandler = (function () {
    const handleSummary = (selector) => {
        const form = $(selector);
        form.closest('.modal').on('app.load-data', function () {
            handleSummary(selector);
        });
        // find unit price
        const select = form.find('[name="order_form_product_id"]');
        const option = select.find(`option[value="${select.val()}"]`);
        const unitPrice = option.data('unit_price');
        // find quantity
        const quantity = form.find('[name="quantity"]').val();
        let summary;
        const element = form.find('[data-app-summary]');
        if (quantity && unitPrice) {
            summary = parseInt(quantity) * parseFloat(unitPrice);
        }
        if (summary && !isNaN(summary)) {
            element.text(`${summary.toFixed(2)} zł`);
        }
        else {
            element.text('-');
        }
    };
    const setupSummaryChangeHandler = (selector) => {
        const form = $(selector);
        form.closest('.modal').on('app.load-data', function () {
            console.log('loaded');
            handleSummary(selector);
        });
        const inputs = form.find('[name="order_form_product_id"], [name="quantity"]');
        inputs
            .on('change', function () {
            handleSummary(selector);
        })
            .trigger('change');
    };
    const handleMemberSummary = (selector) => {
        const form = $(selector);
        // find netto price
        const nettoPrice = form.find('[name="netto_price"]').val();
        // find quantity
        const quantity = form.find('[name="quantity"]').val();
        let summary;
        const element = form.find('[data-app-member_summary]');
        if (quantity && nettoPrice) {
            summary = parseInt(quantity) * parseFloat(nettoPrice);
        }
        if (summary && !isNaN(summary)) {
            element.text(`${summary.toFixed(2)} zł`);
        }
        else {
            element.text('-');
        }
    };
    const setupMemberSummaryChangeHandler = (selector) => {
        const form = $(selector);
        form.closest('.modal').on('app.load-data', function () {
            handleMemberSummary(selector);
        });
        const inputs = form.find('[name="netto_price"], [name="quantity"]');
        inputs
            .on('change', function () {
            handleMemberSummary(selector);
        })
            .trigger('change');
    };
    const setupUnitPriceInSelect = () => {
        // change render function of order_form_product_id select
        const select = $('[name="order_form_product_id"]');
        // wait for initialization
        const selectSetupInterval = setInterval(() => {
            if (!select.hasClass('tomselected')) {
                return;
            }
            clearInterval(selectSetupInterval);
            select.each(function () {
                const selectNode = $(this)[0];
                selectNode.tomselect.settings.render = {
                    ...selectNode.tomselect.settings.render,
                    option: function (data, escape) {
                        let unitPrice;
                        if (data.unit_price && !isNaN(parseFloat(data.unit_price))) {
                            unitPrice = parseFloat(data.unit_price);
                        }
                        return `
              <div>
                ${escape(data.text)}
                ${unitPrice
                            ? `
                  <br>
                  <small>
                    ${unitPrice.toFixed(2)} zł/szt
                  </small>
                `
                            : null}
              </div>
            `;
                    },
                };
            });
        }, 100);
    };
    return {
        // Public functions
        init: function () {
            const select = $('[name="order_form_product_id"]');
            select
                .on('change', function () {
                const option = $(this).find(`option[value="${$(this).val()}"]`);
                const unitPrice = option.data('unit_price');
                if (unitPrice) {
                    $('[data-app-unit_price]')
                        .text(unitPrice.toFixed(2))
                        .closest('div')
                        .show();
                }
                else {
                    $('[data-app-unit_price]').closest('div').hide();
                }
            })
                .trigger('change');
        },
        setupSummaryChangeHandler,
        setupMemberSummaryChangeHandler,
        setupUnitPriceInSelect,
    };
})();
window.OrderFormsShowHandler = _OrderFormsShowHandler;
export {};
